import React, { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import { TemplateCache } from '../services/TemplateCache';

// This component checks if templates are available locally (or if we are online)
// It runs silently in the background to cache templates.

export const ResourceDownloader: React.FC = () => {
    useEffect(() => {
        let isMounted = true;

        const downloadTemplates = async () => {
            if (!Capacitor.isNativePlatform()) {
                return;
            }

            // Check if templates are already downloaded
            const downloadStatus = localStorage.getItem('templates_downloaded');

            // We can double check if cache is actually populated
            const isCached = await TemplateCache.getCacheSize() > 0;

            if (downloadStatus === 'true' && isCached) {
                console.log('Templates already downloaded, skipping...');
                return;
            }

            const { runtimeTemplateData } = await import('../data/runtimeTemplates');
            const templates = runtimeTemplateData.filter(t => t.image.startsWith('http'));

            if (templates.length === 0) {
                return;
            }

            try {
                await TemplateCache.downloadMultiple(
                    templates.map(t => ({ id: t.id, image: t.image })),
                    () => {
                        // Progress can be logged or ignored for background download
                    }
                );

                // Mark templates as downloaded
                if (isMounted) {
                    localStorage.setItem('templates_downloaded', 'true');
                    console.log('All templates downloaded successfully!');
                }
            } catch (error) {
                console.error('Download failed:', error);
            }
        };

        downloadTemplates();

        return () => {
            isMounted = false;
        };
    }, []);

    return null;
};
